import { allTimezones } from 'react-timezone-select';

// Import timezones missing from react-timezone-select for FWC26
export const timezones: { [key: string]: string } = {
    ...allTimezones,
    'America/New_York': 'Eastern Time (New York)',
    'America/Detroit': 'Eastern Time (Detroit)',
    'America/Vancouver': 'Pacific Time (Vancouver)',
    'America/Los_Angeles': 'Pacific Time (Los Angeles)',
    'America/Toronto': 'Eastern Time (Toronto)',
};

// This function will extract the offset from date string, which turns it into local time zone
// Ex: 2024-07-12 00:00:00+02:00 => 2024-07-12 00:00:00
export const switchToLocalTimezone = (date: string) => {
    // The format of date string is YYYY-MM-DDTHH:mm:ss.sssZ
    // For negative offset, we do not want the first two - symbol, so we count from index 8
    const timezoneOffsetIndex = date.indexOf('+') < 0 ? date.indexOf('-', 8) : date.indexOf('+');

    if (timezoneOffsetIndex >= 0) {
        const newDate = date.slice(0, timezoneOffsetIndex);
        return newDate;
    } else if (date.endsWith('Z')) {
        const newDate = date.slice(0, -1);
        return newDate;
    } else {
        return date;
    }
};

// Date time picker component from MUI returns time with the offset of local machine
// This function will convert it to the desired offset
export const switchToTimezone = (date: Date, offset: number) => {
    // Clone the date so the original date does not get affected
    const cloneDate = new Date(date);

    // This part will set the correct time to default UTC time
    const localTimezoneOffset = cloneDate.getTimezoneOffset() / 60;
    const localTimezoneOffsetMinutes = cloneDate.getTimezoneOffset() % 60;
    cloneDate.setHours(date.getHours() - localTimezoneOffset);
    cloneDate.setMinutes(date.getMinutes() - localTimezoneOffsetMinutes);

    // react-timezone-select returns the offset for timezone
    // There are special time zones: +03:30, +05:45,...
    // This will handler the special cases and return the correct string
    let timeZoneOffset = '';
    if (Math.abs(offset % 1) !== 0) {
        const wholePart = Math.trunc(offset);
        const fractionalPart = offset - wholePart;

        switch (Math.abs(fractionalPart)) {
            case 0.5:
                timeZoneOffset = `${wholePart >= 0 ? `+${wholePart}` : wholePart}:30`;
                break;
            case 0.75:
                timeZoneOffset = `${wholePart >= 0 ? `+${wholePart}` : wholePart}:45`;
                break;
        }
    } else {
        timeZoneOffset = `${offset >= 0 ? `+${offset}` : offset}`;
    }

    return cloneDate.toISOString().replace('Z', timeZoneOffset);
};
